import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { showError } from '@utils';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'constants/queryKeys';
import { boardsServices, fleetVehiclesServices } from '@services';
import { useAssignees } from 'hooks/common';
import {
  filterGreenCardAssignees,
  filterGreenCardCommentsUsers,
  handleGreenCardTaskData,
  handleVehicleData,
} from './utils';

export const useGreenCardTaskOperations = () => {
  const router = useRouter();
  const { assignees: allAssignees, isFetching: isAssigneesFetching } =
    useAssignees();
  const assignees = filterGreenCardAssignees(allAssignees);
  const commentsUsers = filterGreenCardCommentsUsers(allAssignees);
  const greenCardTaskId = router.query?.greenCardTaskId;

  const greenCardTaskResponse = useQuery(
    [QUERY_KEYS.GET_GREEN_CARD_TASK_KEY, greenCardTaskId],
    () => boardsServices.getTaskById(greenCardTaskId),
    {
      enabled: !!greenCardTaskId,
    }
  );

  const greenCardTask = handleGreenCardTaskData(
    greenCardTaskResponse?.data?.data,
    assignees
  );
  const carId = greenCardTask.customFields?.carId;

  const vehicleResponse = useQuery(
    [QUERY_KEYS.GET_VEHICLE_BY_INTERNAL_ID_KEY, greenCardTaskId],
    () => fleetVehiclesServices.getVehicleByInternalId(carId),
    {
      enabled: greenCardTaskResponse?.isFetched && !!carId,
    }
  );

  const vehicle = handleVehicleData(vehicleResponse?.data?.data);

  useEffect(() => {
    if (greenCardTaskResponse?.isError) {
      showError(greenCardTaskResponse?.error);
    }
  }, [greenCardTaskResponse?.isError]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (vehicleResponse?.isError) {
      showError(vehicleResponse?.error);
    }
  }, [vehicleResponse?.isError]); // eslint-disable-line react-hooks/exhaustive-deps

  const loading =
    greenCardTaskResponse?.isFetching ||
    vehicleResponse?.isFetching ||
    isAssigneesFetching;

  return {
    loading,
    task: greenCardTask,
    taskId: greenCardTaskId,
    vehicle,
    assignees,
    commentsUsers,
    getGreenCardTask: greenCardTaskResponse?.refetch,
  };
};
